<template>
  <section>
    <v-card>
      <v-card-title class="chart-title" primary-title>
        School Registrations by Gender (%)
      </v-card-title>
      <v-select
        :items="dropDown"
        label="View month or total registrations"
        class="graphSelect pl-3 pt-4"
        v-model="dropDownSelection"
      ></v-select>
      <v-row>
        <v-col cols="12">
          <pie-chart
            :chart-data="data"
            :options="options"
            class="pa-2 chart-layout"
          />
        </v-col>
      </v-row>
    </v-card>
  </section>
</template>

<script>
import PieChart from '../charts/PieChart'
import { mapState } from 'vuex'

export default {
  components: {
    PieChart
  },
  data: () => ({
    dropDown: [
      { text: 'Registrations this month', value: 'monthDataset' },
      { text: 'Total Registrations', value: 'overallDataset' }
    ],
    dropDownSelection: 'monthDataset',
    data: {
      labels: ['Co-ed', 'Boys', 'Girls'],
      datasets: [
        {
          label: 'Registrations by School Gender',
          backgroundColor: ['#900048', '#099A97', '#9764C7'],
          data: ['35', '20', '18']
        }
      ]
    },
    options: {
      maintainAspectRatio: false,
      legend: {
        display: true,
        position: 'left'
      },
      plugins: {
        datalabels: {
          display: false
        }
      }
    }
  }),
  watch: {
    dropDownSelection(value) {
      return value == 'monthDataset'
        ? (this.data = this.monthDataset)
        : (this.data = this.overallDataset)
    }
  },
  computed: {
    ...mapState(['lessonTerm']),
    monthDataset() {
      return {
        labels: ['Co-ed', 'Boys', 'Girls'],
        datasets: [
          {
            label: `${this.capitalizeFirstLetter(
              this.lessonTerm
            )} usage previous month`,
            backgroundColor: ['#900048', '#099A97', '#9764C7'],
            data: ['35', '20', '18']
          }
        ]
      }
    },
    overallDataset() {
      return {
        labels: ['Co-ed', 'Boys', 'Girls'],
        datasets: [
          {
            label: `${this.capitalizeFirstLetter(
              this.lessonTerm
            )} usage overall`,
            backgroundColor: ['#900048', '#099A97', '#9764C7'],
            data: ['35', '20', '18']
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chart-layout {
  height: 220px !important;
}
</style>
